import React from "react";
import { useTranslation } from "react-i18next";
import { startingPageImg } from "../../assets/images/index";
import { RouterConstant } from "../../routers/index";
import NextButton from "../../components/next-button";
import Button from "../../components/button";
import { useLayoutContext } from "../../layouts/general-layout";
import { useNavigate } from "react-router-dom";
import { isMobileDevice } from "../../utils/utils";
import "./startingpage1.scss";

export default function Index() {
  const { t } = useLayoutContext();
  const { i18n } = useTranslation();
  const { ROUTERS_PATH } = RouterConstant;
  const navigate = useNavigate();

  const heandleLoginAsAdmin = (fromAdminLogin: boolean) => {
    navigate(ROUTERS_PATH.LOGIN, { state: { fromAdminLogin } });
  };

  const langMap: { [key: string]: string } = { 'עיברית': 'he', 'ערבית': 'ar' };
  const langDisplay: { [key: string]: string } = { 'he': 'עיברית', 'ar': 'ערבית' };

  return (
    <div className="full-head-template starting-page">
      <div className="starting-page-body">
        {/* <div className="language-switcher">
          {['עיברית', 'ערבית'].map(label => (
            <button
              key={label}
              onClick={() => i18n.changeLanguage(langMap[label])}
              className={i18n.language === langMap[label] ? 'active' : ''}
            >
              {label}
            </button>
          ))}
        </div> */}
        <div className="starting-page-image">
          <img src={startingPageImg} alt="MainImage" />
        </div>
        <div>
          <h4 className="starting-page-title">
            {t("studyMath")}<br /><span>{t("StartPageTitle")}</span>
          </h4>
        </div>
      </div>
      <div className="starting-page-action">
        {!isMobileDevice() &&
          <div className="admin-btn-container">
            <Button text={t("systemadmin")} className="admin-btn" onClick={() => heandleLoginAsAdmin(true)} />
          </div>
        }
        <div className="users-btn-container">
          <span>{t("shallWeBegin")}</span>
          <NextButton link={ROUTERS_PATH.USERREGISTRATIONINITIAL} />
        </div>
      </div>
    </div>
  );
}
